import { render, staticRenderFns } from "./zhanghaomimadl.vue?vue&type=template&id=56972bca&scoped=true"
import script from "./zhanghaomimadl.vue?vue&type=script&lang=js"
export * from "./zhanghaomimadl.vue?vue&type=script&lang=js"
import style0 from "./zhanghaomimadl.vue?vue&type=style&index=0&id=56972bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56972bca",
  null
  
)

export default component.exports